import { isMyAppWKWebView } from "./isMyAppWKWebView";

type HapticFeedbackStyle = "heavy" | "light" | "medium" | "rigid" | "soft";

export interface HapticFeedbackConfig {
  style: HapticFeedbackStyle;
  intensity?: number;
}

export async function playHapticFeedback(config: HapticFeedbackConfig) {
  if (window.Android) {
    return window.Android.playHapticFeedback(
      config.style,
      config.intensity ?? 1
    );
  }

  if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return (window.webkit as any).messageHandlers.playHapticFeedback.postMessage(config);
  }

  return;
}
